import { render } from "./DrawSVGPluginNr3.vue?vue&type=template&id=5caad916&scoped=true"
import script from "./DrawSVGPluginNr3.vue?vue&type=script&lang=js"
export * from "./DrawSVGPluginNr3.vue?vue&type=script&lang=js"

import "./DrawSVGPluginNr3.vue?vue&type=style&index=0&id=5caad916&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caad916"]])

export default __exports__